import clientId from './clientid';

function onBeforeUnload() {
	// We want to preserve our clientId across a refresh so we always write our clientId
	// into local storage when unloading the client
	window.localStorage.setItem('xc-next-clientid-cap', clientId);
}
window.addEventListener('beforeunload', onBeforeUnload);


// WEBPACK FOOTER //
// ./src/utils/beforeunload.js